import "../styles/programs.css";

import CommunityBuilding from "../assets/community-building.jpg";
import AwarenessPrevention from "../assets/awareness-prevention.jpg";
import ResourcesEducation from "../assets/resources-education.jpg";

const Programs = () => {
  const programs = [
    {
      number: "01",
      title: "Community Building",
      description:
        "We believe that building a sense of community is key to addressing issues that plague families across America. We work to bring people together and foster a supportive environment that promotes healing and growth.",
      image: CommunityBuilding,
    },
    {
      number: "02",
      title: "Awareness & Prevention",
      description:
        "Education and awareness are powerful tools for preventing drug abuse, domestic violence, and homelessness. We provide resources that empower people to take action before these issues occur.",
      image: AwarenessPrevention,
    },
    {
      number: "03",
      title: "Resources & Education",
      description:
        "Access to resources and education is essential for overcoming life's challenges. We help individuals and communities find the tools they need to build brighter futures.",
      image: ResourcesEducation,
    },
  ];

  return (
    <section id="programs-section">
      <div className="container-fluid programs-container">
        <div className="programs-header">
          <span>What We Do</span>

          <h2>
            BOOTS TO THE
            <br />
            GROUND.
          </h2>
        </div>

        <div className="programs-grid">
          {programs.map((program) => (
            <div
              className="program-card"
              key={program.number}
              style={{ backgroundImage: `url(${program.image})` }}
            >
              <div className="program-overlay"></div>

              <div className="program-content">
                <span className="program-number">{program.number}</span>

                <h3>{program.title}</h3>

                <p>{program.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;